
import { OnInit, Component } from '@angular/core';


@Component({
    selector: 'app-menuValoracion',
    styleUrls: ['./menu-valoracion.component.css'],
    templateUrl: './menu-valoracion.component.html'
})

export class MenuValoracion implements OnInit {

    constructor() { }

    ngOnInit() { }

}